import { useState, useEffect } from 'react';
import { apiClient } from '../context/AuthContext';

// Note: canonical link is handled globally in Layout.js (single source of truth).
// We DO NOT return any hardcoded fallback data. If the API call fails, seoData
// stays null so consuming pages won't overwrite the (correct) pre-rendered tags.

export default function useSEOPage(pageId) {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const { data } = await apiClient.get(`/seo-pages/public/${pageId}`);
        setSeoData(data);
      } catch (error) {
        console.warn('SEO data unavailable for', pageId, '— keeping pre-rendered tags');
        setSeoData(null);
      } finally {
        setLoading(false);
      }
    };

    if (pageId) {
      fetchSEO();
    }
  }, [pageId]);

  return { seoData, loading };
}
